export class Page<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    isLoaded: boolean;

    constructor(typeT?: new (data: any) => T, data?: any) {
        if (data?.content && typeT) {
            this.content = data.content.map((item: any) => new typeT(item));
        } else {
            this.content = [];
        }
        this.totalElements = data?.totalElements ?? 0;
        this.totalPages = data?.totalPages ?? 0;
        this.size = data?.size ?? 10;
        this.number = data?.number ?? 0;
        this.isLoaded = data?.isLoaded ?? false;
    }
}